// API.js
export const API = 'https://www.wynecellar.com/api';
// export const API = 'https://www.wynecellar.com/test_api';
// export const API = 'https://test.wynecellar.com/api'
// export const API = `${window.location.protocol}//${window.location.host}/api`;